import Http from "./http";

export const deleteNotifications = (data) => {
  return Http.post("admin/deleteNotification",data);
};
